
export interface IUserNotificationTemplateAlertInfoHttpResponse {
    userId: number;
    userName: string;
    notificationTemplateId: number;
    notificationTemplateName: string;
    isEmailChecked: boolean;
    isFirebaseChecked: boolean;
    isTaskChecked: boolean;
}

export class UserNotificationTemplateAlertInfo {
    constructor(
        public userId: number,
        public userName: string,
        public notificationTemplateId: number,
        public notificationTemplateName: string,
        public isEmailChecked: boolean,
        public isFirebaseChecked: boolean,
        public isTaskChecked: boolean
    ) { }

    public static adapt(data: IUserNotificationTemplateAlertInfoHttpResponse) {
        return new this(
            data.userId,
            data.userName,
            data.notificationTemplateId,
            data.notificationTemplateName,
            data.isEmailChecked,
            data.isFirebaseChecked,
            data.isTaskChecked
        );
    }
}

export class NotificationTemplateSaveModel {
    userAlertList: UserNotificationTemplateAlertInfo[];

    constructor() {
        this.userAlertList = [];
    }
}